export default "__VITE_ASSET__Dph28WYq__"